<template>
  <div>
    <a-modal
      :title="'归档学生'"
      :maskClosable="false"
      :width="1250"
      :visible="visible"
      :confirmLoading="confirmLoading"
      :cancelText="'取消'"
      :okText="'确定'"
      @cancel="handleCancel"
      :footer="null"
    >
      <div class="class-list">
        <a-form layout="inline">
          <a-form-item class="name" label="姓名">
            <a-input
              class="form-cell"
              type="text"
              placeholder="请输入"
              v-model="queryParam.studentName"
            ></a-input>
          </a-form-item>
          <a-form-item class="name" label="学号">
            <a-input
              class="form-cell"
              type="text"
              placeholder="请输入"
              v-model="queryParam.studentNumber"
            ></a-input>
          </a-form-item>
          <a-form-item label="年级">
            <a-select
              class="form-cell"
              placeholder="请选择"
              v-model="queryParam.gradeId"
            >
              <a-select-option
                v-for="(item, index) in $store.getters.getGradeScope"
                :key="index"
                :value="item.id"
                >{{ item.tagName }}</a-select-option
              >
            </a-select>
          </a-form-item>
          <a-form-item label="性别">
            <a-select
              class="form-cell"
              placeholder="请选择"
              v-model="queryParam.gender"
            >
              <a-select-option
                v-for="(item, index) in $store.getters.gender"
                :key="index"
                :value="item.value"
                >{{ item.code }}</a-select-option
              >
            </a-select>
          </a-form-item>
          <!-- <a-form-item class="name" label="家长昵称">
            <a-input
              class="form-cell"
              type="text"
              placeholder="请输入"
              v-model="queryParam.nickname"
            ></a-input>
          </a-form-item>
          <a-form-item class="name" label="家长电话">
            <a-input
              class="form-cell"
              type="text"
              placeholder="请输入"
              v-model="queryParam.mobile"
            ></a-input>
          </a-form-item> -->
          <!-- <c-original-class :classCode.sync="queryParam.originalClassId"></c-original-class> -->
          <div class="search-oper">
            <a-button type="primary" @click="headleChange()">查询</a-button>
            <a-button type="primary" @click="reset()">重置</a-button>
            <a @click="exportStudent">导出</a>
            <a-button type="primary" :disabled="selectedRowKeys.length==0" @click="batchCancelArchiveSelectRow()" title="选择学生进行操作">
              取消归档
            </a-button>
          </div>
        </a-form>

        <!-- 表格数据 -->
        <template>
          <a-table
            :columns="columns"
            :dataSource="studentList"
            @change="tableChange"
            :pagination="pagination"
            :rowSelection="rowSelection"
            rowKey="id"
          >
            <span slot="bindParents" slot-scope="text, record">
              <template>
                <a-popover
                  placement="rightTop"
                  v-if="record.bindParents == '是'"
                >
                  <template #content>
                    <p>{{ record.teaParents }}</p>
                  </template>
                  <span
                    >{{ record.bindParents
                    }}<a-icon style="margin-left: 3px" type="search"
                  /></span>
                </a-popover>
                <span v-else>{{ record.bindParents }}</span>
              </template>
            </span>
          </a-table>
        </template>
      </div>
    </a-modal>
  </div>
</template>

<script>
import student from '../../api/student'
import COriginalClass from '@/components/COriginalClass'
const columns = [
  {
    title: '姓名',
    dataIndex: 'studentName',
  },
  {
    title: '性别',
    dataIndex: 'genderText',
    width: 60,
  },
  {
    title: '生日',
    dataIndex: 'birthday',
  },
  {
    title: '学号',
    dataIndex: 'studentNumber',
  },
  {
    title: '原始班级',
    dataIndex: 'className',
  },
  {
    title: '年级',
    dataIndex: 'gradeName',
  },
  {
    title: '学校名称',
    dataIndex: 'schoolName',
  },
  {
    title: '是否绑定家长',
    dataIndex: 'bindParents',
    scopedSlots: { customRender: 'bindParents' },
  },
  {
    title: '归档时间',
    dataIndex: 'archiveTime',
  },
]

export default {
  name: 'studentArchive',
  data() {
    return {
      columns: JSON.parse(JSON.stringify(columns)),
      visible: false,
      confirmLoading: false,
      studentList: [], //学生列表
      // classInfo: null, //学生信息
      // tabIndex: '1',
      // selectedStudent: [], //选择的学生
      // roleId: '',
      // refreshTable: true,
      queryParam: {}, //查询参数
      pagination: {
        showTotal: (total) => `总共 ${total} 条`, // 显示总数
      },
      selectedRowKeys: []
      // offeringType: '', // 判断是学校还是课程方账号
    }
  },
  components: {
    COriginalClass,
  },
  computed: {
    rowSelection() {
      const { selectedRowKeys } = this
      return {
        selectedRowKeys,
        onChange: (selectedRowKeys) => {
          this.selectedRowKeys = selectedRowKeys
        },
      }
    },
  },
  methods: {
    // 查询
    headleChange() {
      // 解决不点重置手动删除bug
      for (let k in this.queryParam) {
        if (this.queryParam[k] == '') {
          delete this.queryParam[k]
        }
      }
      this.queryParam.currentPage = 1
      this.archiveStudent(this.queryParam)
    },

    //前端模拟删除
    deleteClassData(data, id) {
      for (let i in data) {
        if (data[i].id == id) {
          data.splice(i, 1)
          break
        }
      }
    },

    //获取归档学生
    archiveStudent(params) {
      this.visible = true
      student.archiveStudent(params).then((res) => {
        console.log('归档学生列表是', res)
        this.studentList = res.data.list.map((item) => {
          if (item.parentCount == 0) {
            return { ...item, bindParents: '否' }
          } else if (item.parentCount != 0) {
            return { ...item, bindParents: '是' }
          } else {
            return item
          }
        })
        //分页信息
        this.pagination = res.data.pagination
      })
    },

    // 切换分页
    tableChange(pagination, filters, sorter) {
      //如果查询有地址的话，把地址解析之后带入
      let obj = {}
      obj.currentPage = pagination.current
      //存在排序的时候
      if (sorter && sorter.columnKey) {
        obj.sorter = `${sorter.columnKey}-${
          sorter.order == 'ascend' ? 'asc' : 'desc'
        }`
      }
      this.archiveStudent(obj)
    },

    //隐藏
    handleCancel() {
      this.visible = false
    },
    // 重置
    reset() {
      this.queryParam = {}
    },
    // 导出归档学生
    exportStudent() {
      let _this = this
      this.$confirm({
        title: '注意',
        okText: '确定',
        cancelText: '取消',
        icon:'exclamation-circle',
        content:
          '注意：仅支持导出1万条数据记录，如需导出更多数据请提出人工导出申请',
        onOk() {
          let params = { ..._this.queryParam }
          for (let k in params) {
            if (params[k] == '') {
              delete params[k]
            }
          }
          _this.$message.success('导出中...')
          student.exportArchiveStudent(params).then((res) => {
            console.log(res)
            window.location.href = res.targetUrl
          })
        },
      })
    },
    // 表格取消归档选中的学生
    batchCancelArchiveSelectRow() {
      if (this.selectedRowKeys.length == 0) {
        this.$message.error('请勾选需要取消归档的学生项')
        return
      }
      if (confirm("需要取消归档的学生项:"+this.selectedRowKeys.length+",如果原班级已被归档也会被取消归档并还原，确定吗？")){
        student.batchCancelArchive({ ids: this.selectedRowKeys.join() }).then((res) => {
          this.$message.success('取消归档成功')
          this.headleChange()
          this.selectedRowKeys = []
        }).catch(reason => {
          this.headleChange();
          this.selectedRowKeys = []
        })     
      }

    },
  },
  created() {},
}
</script>
<style lang="scss" scoped>
@import 'src/config/var';
.class-list {
  height: calc(100vh - 320px);
  overflow-y: auto;
  overflow-x: hidden;
  .oper {
    text-align: right;
    margin-bottom: 10px;
    margin-top: 14px;
    margin-left: 4px;
    > .export {
      float: left;
      margin-left: 10px;
      margin-bottom: 10px;
      z-index: 999;
    }
  }
}
.class-cell {
  font-size: 14px;
  color: $normal-color-dark;
  line-height: 26px;
}
.tab-active {
  color: $primary-color;
}

.transfer-class {
  float: left;
  margin-bottom: 10px;
  z-index: 999;
}
.shift-class {
  float: left;
  margin-left: 10px;
  margin-bottom: 10px;
  z-index: 999;
}
.search-oper {
  margin: 15px 0;
  button {
    margin: 0px 5px;
  }
  a {
    margin-left: 10px;
  }
}
/deep/.ant-modal-title {
  font-weight: bold;
}
</style>
